import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'

Vue.config.productionTip = false

Vue.directive('statemachine', {
	bind: function (el, binding) {
		binding.value.bind(el);
	},
	unbind: function(el, binding) {
		binding.value.unbind();
	},
})

store.commit('initState');
store.commit('createData');

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
